import { render, staticRenderFns } from "./ComHeader.vue?vue&type=template&id=7cb4646a&scoped=true&"
import script from "./ComHeader.vue?vue&type=script&lang=js&"
export * from "./ComHeader.vue?vue&type=script&lang=js&"
import style0 from "./ComHeader.vue?vue&type=style&index=0&id=7cb4646a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4646a",
  null
  
)

export default component.exports